angular.module('impactx.deliverynote').controller('DeliveryNoteDetailCtrl', DeliveryNoteDetailCtrl);
DeliveryNoteDetailCtrl.$inject = [
    '$scope',
    'dataGen',
    '$routeParams',
    'BackService',
    '$redirect',
    '$mdDialog',
    'OutsourcedCommentSaveService',
    'ToolbarService',
    'AppConfiguration',
    'ToastService',
    'TranslationService'
];

function DeliveryNoteDetailCtrl($scope, dataGen, $routeParams, BackService, $redirect, $mdDialog, OutsourcedCommentSaveService,
                                ToolbarService, AppConfiguration, ToastService, TranslationService) {
    var self = this;
    var useSimpleComplaint = AppConfiguration.get("useSimpleComplaint");
    $scope.selectedItems = [];

    $scope.check = function (evt) {
        return dataGen.postAsForm({}, {dnhDTO: $scope.data.dnh}, "/deliverynote/check").then(function (checkResult) {
            if (checkResult.data) {
                if (!checkResult.data.hasErrors && checkResult.data.noComplaintForCorrectDelivery
                    && !checkResult.data.hasOvershipment && !checkResult.data.hasPartialDelivery) {
                    // no complaint for correct delivery notes, close directly
                    var extractedComments = OutsourcedCommentSaveService.extractComments($scope.data.dnh);
                    $scope.data.dnh.acceptOthers = true;
                    var dataObj = {
                        data: $scope.data,
                        fromReadOnly: false
                    };
                    dataGen.post($scope, dataObj, "/deliverynote/saveAndClose").then(function (data) {
                        if (data && data.data && data.data.commentData) {
                            OutsourcedCommentSaveService.saveComments(data.data.commentData, extractedComments);
                        }
                        BackService.back();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(parent.trns.SaveSuccess)
                                .position("bottom right")
                                .hideDelay(10000)
                        );
                    }, function () {
                        OutsourcedCommentSaveService.restoreComments($scope.data.dnh, extractedComments);
                    });
                }
                else {
                    $mdDialog.show({
                        templateUrl: 'modules/deliverynote/templates/closeactiondialog.html',
                        targetEvent: evt,
                        locals: {parent: $scope, fromReadOnly: true, checkResult: checkResult},
                        controller: 'SaveDeliveryNoteAndCloseCtrl',
                        controllerAs: 'saveDeliveryNoteAndCloseCtrl',
                        bindToController: true,
                        clickOutsideToClose: true,
                        fullscreen: true
                    }).then(function (data) {
                        if (!isUndefined(data)) {
                            if (data.followCphId < 0) {
                                BackService.back();
                            }
                            else {
                                var check = "true";
                                var acceptPartialDelivery = "true";
                                var acceptOverShipment = "true";
                                var needsAllItems = "true";
                                if (!data.checkItems) {
                                    check = "false";
                                }
                                if (!$scope.data.dnh.acceptPartialDelivery) {
                                    acceptPartialDelivery = "false";
                                }
                                if (!$scope.data.dnh.acceptOverShipment) {
                                    acceptOverShipment = "false";
                                }
                                if (!data.needsAllItems) {
                                    needsAllItems = "false";
                                }
                                $redirect.redirectTo(null, "/deliverycomplaint/" + data.followCphId + "/" + $scope.data.dnh.id + "/0/" + check + "/" +
                                    acceptPartialDelivery + "/" + acceptOverShipment + "/" + needsAllItems);
                            }
                        }
                    });
                }
            }
        });
    };

    dataGen.getData($scope, {id: $routeParams.id}, "/deliverynote/view").then(function () {
        defineButtons();
    });

    self.showDetailDialog = function (event) {
        var item = $scope.selectedItems[0];
        $mdDialog.show({
            controller: "DeliveryNoteItemDetailCtrl",
            controllerAs: 'deliveryNoteItemDetailCtrl',
            templateUrl: 'modules/deliverynote/templates/deliverynote-item-detail.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                item: JSON.parse(JSON.stringify(item)),
                trns: $scope.trns,
                readOnly: true
            }
        }).then(function (returned) {
            var itemReturn = returned.item;
            item.supplierNo = itemReturn.supplierNo;
            item.productName = itemReturn.productName;
            item.attributes = itemReturn.attributes;
        });
    };

    self.showSerialNumberDialog = function (event) {
        var item = $scope.selectedItems[0];
        $mdDialog.show({
            controller: "DeliveryNoteSerialNumberCtrl",
            controllerAs: 'deliveryNoteSerialNumberCtrl',
            templateUrl: 'modules/deliverynote/templates/deliverynote-serial-number.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                item: JSON.parse(JSON.stringify(item)),
                trns: $scope.trns,
                readOnly: true
            }
        }).then(function (returned) {
            var itemReturn = returned.item;
            item.dniInfoItems = itemReturn.dniInfoItems;
        });
    };

    self.showChangeItemDeliveryDateDialog = function (event) {
        $mdDialog.show({
            controller: "ChangeItemDeliveryDateDialogController",
            controllerAs: 'changeItemDeliveryDateDialogController',
            templateUrl: 'modules/deliverynote/templates/deliverynote-change-item-delivery-date-dialog.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                items: $scope.selectedItems,
                dnhId: $scope.data.dnh.id,
                trns: $scope.trns,
                arrivalDate: angular.copy($scope.data.dnh.arrivalDate)
            }
        });
    };

    self.redirectToMatchList = function () {
        $redirect.redirectTo(null, "/invoice/acceptedunmatched/", [$scope.data.dnh.id]);
    };

    $scope.checkItemSelected = function (item) {
        return item.selected || (item.replacementProduct && item.replacementProduct.selected);
    };

    self.canInvalidate = function() {
        return $scope.data.dnh.canInvalidate;
    };

    self.showInvalidationDialog = function (event) {
        $mdDialog.show({
            controller: "DeliveryNoteInvalidationDetailCtrl",
            controllerAs: 'deliveryNoteInvalidationDetailCtrl',
            templateUrl: 'modules/deliverynote/templates/deliverynote-invalidation-detail.tmpl.html',
            parent: angular.element(document.body),
            targetEvent: event,
            clickOutsideToClose: false,
            locals: {
                dnhId: $scope.data.dnh.id
            }
        });
    };

    self.canUndoInvalidate = function() {
        return $scope.data.dnh.canUndoInvalidate;
    };

    self.undoInvalidate = function () {
        return dataGen.postAsForm({}, {id: $scope.data.dnh.id}, "/deliverynote/undoInvalidation").then(function () {
            $redirect.redirectTo(null, "/invaliddeliverynotelist");
            ToastService.openStandardToast(TranslationService.get("saveSuccess"));
        });
    };


    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.checkDelNote,
                action: $scope.check,
                type: 'dialogaction',
                condition: hasCloseRight
            },
            {
                label: $scope.trns.newComplaint,
                action: goToComplaint,
                type: 'dialogAction',
                condition: canComplain
            },
            {
                label: $scope.trns.complaints,
                linkFunction: getComplaintListLink,
                type: 'link',
                condition: canViewComplaints,
                process: 'DeliveryComplaint'
            },
            {
                label: $scope.trns.details,
                action: self.showDetailDialog,
                type: 'dialogaction',
                condition: canShowDetailDialog
            },
            {
                label: $scope.trns.serialNumbers,
                action: self.showSerialNumberDialog,
                type: 'dialogaction',
                condition: canShowSerialNumberDialog
            },
            {
                label: $scope.trns.changeItemDeliveryDate,
                action: self.showChangeItemDeliveryDateDialog,
                type: 'dialogaction',
                condition: canChangeItemDeliveryDate
            },
            {
                label: $scope.trns.print,
                type: 'print',
                condition: canPrint,
                params: {
                    printToken: $scope.printTokens.delivery
                }
            },
            {
                label: $scope.trns.match,
                action: self.redirectToMatchList,
                type: 'dialogaction',
                condition: canMatch
            },
            {   label: $scope.trns.invalidate,
                action: self.showInvalidationDialog,
                type:'dialogaction',
                condition: self.canInvalidate,
                process: 'InvalidDeliveryNote'
            },
            {   label: $scope.trns.undoInvalidation,
                action: self.undoInvalidate,
                type:'dialogaction',
                condition: self.canUndoInvalidate,
                process: 'InvalidDeliveryNote'
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function canMatch() {
        return !$scope.data.dnh.isInvalid && $scope.data.dnh.canMatchAcceptedInvoice;
    }

    function hasCloseRight() {
        return !$scope.data.dnh.isInvalid && $scope.data.dnh.closeRight;
    }

    function canComplain() {
        return !$scope.data.dnh.isInvalid && $scope.data.dnh.canComplain;
    }

    function canViewComplaints() {
        return !$scope.data.dnh.isInvalid && $scope.data.dnh.hasComplaints && $scope.data.dnh.canComplain;
    }

    function canChangeItemDeliveryDate() {
        return !$scope.data.dnh.isInvalid && $scope.data.dnh.canChangeItemDeliveryDate && $scope.selectedItems.length > 0;
    }

    function canPrint() {
        return $scope.data.id > 0;
    }

    function canShowDetailDialog() {
        return !$scope.data.dnh.isInvalid && $scope.selectedItems.length === 1;
    }

    function canShowSerialNumberDialog() {
        return !$scope.data.dnh.isInvalid && $scope.selectedItems.length === 1;
    }

    function goToComplaint() {
        // not a link anymore but an action because we need to set the item ids to the redirect service
        var itemIds = [];
        angular.forEach($scope.selectedItems, function(item){
            itemIds.push(item.id);
        });
        if(useSimpleComplaint) {
            $redirect.redirectTo(null, '/simplecomplaint/0/' + $scope.data.dnh.id, {dniIds: itemIds});
        }
        else {
            $redirect.redirectTo(null, "deliverycomplaint/0/" + $scope.data.dnh.id, {dniIds: itemIds});
        }
    }

    function getComplaintListLink() {
        return "deliverycomplaintlist/" + $scope.data.dnh.id;
    }

    $scope.handleSkippableErrors = function(data) {
        if (!$scope.skipErrors) {
            $scope.clearSkippedErrors();
        }
        if (data.errors) {
            angular.forEach(data.errors, function (error) {
                if (error && error.code) {
                    $scope.skipErrors.push(error.code);
                }
            })
        }
    };

    $scope.clearSkippedErrors = function() {
        $scope.skipErrors = [];
    };
}